import { render, staticRenderFns } from "./ElectricalDamageType.vue?vue&type=template&id=e115d622"
import script from "./ElectricalDamageType.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageType.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageType.vue?vue&type=style&index=0&id=e115d622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports